<template>
  <v-container>
    <v-row class="pa-0 ma-0">
      <v-col class="col-12 pa-3">
        <h1>Bulk Enroll Users</h1>
        <p>
          Upload a list of phone numbers. Arist will text each phone number and
          request that they join the selected course.
        </p>
        <growthalert v-model="isGrowth" />
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0">
      <v-col class="col-12 col-md-6">
        <v-card flat="" outlined="" min-height="100%">
          <v-card-title class="mb-0 pb-0"
            ><b>Select a course from your homepage</b></v-card-title
          >
          <v-card-text>
            These are courses that allow signup's just through phone numbers.
            <router-link :to="{ name: 'coursedelivery' }">
              Manage this list here
            </router-link>
          </v-card-text>
          <div style="overflow-x:hidden; overflow-y:auto;max-height:500px">
            <selectdistribution v-model="distribution" :readonly="uploading" />
          </div>
        </v-card>
      </v-col>
      <v-col class="col-12 col-md-6">
        <v-card flat="" outlined="">
          <v-card-title><b>Upload Excel / CSV</b></v-card-title>
          <v-card-subtitle
            >Download our recommended excel template
            <a href="https://drive.google.com/file/d/1uTR_RbZJSq4fTTmty9I2gOLEPyWEcIb_/view?usp=sharing" target="download"
              >here.</a
            ></v-card-subtitle
          >
          <v-card-text>
            <droparea v-model="file" :disabled="uploading || !isGrowth" />
            <v-file-input
              :disabled="uploading || !isGrowth"
              ref="file-input"
              class="mt-4"
              label="Upload a Excel / CSV Sheet"
              prepend-inner-icon="mdi-paperclip"
              outlined
              clear-icon=""
              prepend-icon=""
              v-model="file"
              dense
              :show-size="true"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            ></v-file-input>
            <h4 class="mb-1 mt-3">Match Columns</h4>
            <v-form @submit="upload">
              <!-- <v-select
                :disabled="!file"
                :readonly="uploading"
                :items="[{ value: null, text: 'NONE' }, ...keys]"
                dense=""
                label="Identity Column"
                outlined
                v-model="form.alias"
              ></v-select> -->
              <v-select
                :readonly="uploading"
                :disabled="!file"
                :items="keys"
                label="Phone Number Column"
                outlined
                dense=""
                v-model="form.phone"
              ></v-select>
              <v-select
                :readonly="uploading"
                :disabled="!file"
                :items="types"
                label="Type of Upload"
                outlined
                dense=""
                v-model="form.type"
              ></v-select>
            </v-form>
          </v-card-text>
          <v-card-text v-if="readyToSubmit">
            <div class="body-1 d-flex">
              <v-checkbox
                color="red"
                dense=""
                hide-details=""
                v-model="form.approved"
                class="mt-auto mb-auto mr-3"
              ></v-checkbox>
              <p class="mt-auto mb-auto">
                Send all <b>{{ totalRows }}</b> phone numbers a message right
                now on {{ new Date().toDateString() }} at
                {{ new Date().toTimeString() }}
              </p>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="upload"
              depressed=""
              color="blue"
              class="white--text"
              :loading="uploading"
              :disabled="
                !readyToSubmit || uploading || !form.approved || !isGrowth
              "
              >Upload and Enroll</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col class="col-12" v-if="results && results.length > 0">
        <v-card flat="" outlined="">
          <v-card-title
            ><b>Upload Results</b> <v-spacer></v-spacer>
            <v-text-field
              class="mt-auto mb-auto"
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field
          ></v-card-title>
          <v-data-table
            :search="search"
            :headers="headers"
            :items="results"
            :items-per-page="100"
            :footer-props="{
              'items-per-page-options': [100, 250, 500, -1]
            }"
          >
            <template v-slot:item.success="{ item }">
              <v-icon
                class="mr-2"
                :color="item && item.token && item.token._id ? 'green' : 'red'"
                >{{
                  item && item.token && item.token._id
                    ? "mdi-check-circle"
                    : "mdi-alert-circle"
                }}</v-icon
              >{{ item && item.token && item.token._id ? "Sent" : "Failed" }}
            </template>
            <template v-slot:item.identity="{ item }">
              {{
                !item.identity ||
                `${item.identity}` == "undefined" ||
                `${item.identity}` == "null"
                  ? "NaN"
                  : item.identity
              }}
            </template>
            <template v-slot:item.tokenphone="{ item }">
              {{
                item && item.token && item.token.sender
                  ? item.token.sender
                  : "NaN"
              }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import selectdistribution from "./select-distribution";
import spreadsheet from "./csv";
import droparea from "@/components/drop-area";
import services from "@/services";
import growthalert from "./growth-needed";
export default {
  components: {
    selectdistribution,
    droparea,
    growthalert
  },
  data: () => ({
    search: "",
    headers: [
      {
        text: "Status",
        align: "start",
        sortable: true,
        value: "success",
        width: "150px"
      },
      { text: "Identity", value: "identity" },
      { text: "Number", value: "phone" },
      { text: "Arist Number Used", value: "tokenphone" }
    ],
    file: null,
    distribution: null,
    sheets: [],
    keys: [],
    uploading: false,
    results: [],
    totalRows: 0,
    isGrowth: false,
    types: [{ text: "SMS", value: "SMS" }, { text: "WhatsApp", value: "WA" }],
    form: {
      approved: false,
      phone: null,
      alias: null,
      type: null
    },
    cleanForm: {
      approved: false,
      phone: null,
      alias: null,
      type: null
    }
  }),
  computed: {
    readyToSubmit() {
      this.getTotalRows();
      return (
        this.file && this.form.phone && this.form.type && this.distribution
      );
    }
  },
  methods: {
    async getTotalRows() {
      this.totalRows = (await this.getRows()).length;
    },
    async upload(e) {
      if (e) {
        e.preventDefault();
      }
      this.uploading = true;
      try {
        const rows = await this.getRows();
        const enrollments = rows.map(obj => {
          return {
            phone: `${obj[this.form.phone]}`,
            identity: `${obj[this.form.alias]}`
          };
        });
        this.results = (await services.enrollments.json.create({
          enrollments: enrollments,
          type: this.form.type,
          skip: true,
          distribution: this.distribution
        })).results;
        console.log("results", this.results);
        this.approved = false;
        this.form = JSON.parse(JSON.stringify(this.cleanForm));
      } catch (err) {
        console.log(err);
      } finally {
        this.uploading = false;
      }
    },
    getRows() {
      return new Promise((resolve, reject) => {
        const fr = new FileReader();
        if (!this.file) {
          return;
        }
        fr.readAsBinaryString(this.file);
        fr.addEventListener("load", async () => {
          let buffer = fr.result;
          const sheet = spreadsheet(buffer, "binary");
          resolve(sheet.getRowsFromSheet((await sheet.getSheets())[0]));
        });
      });
    },
    async findKeys() {
      const fr = new FileReader();
      fr.readAsBinaryString(this.file);
      fr.addEventListener("load", async () => {
        let buffer = fr.result;
        const sheet = spreadsheet(buffer, "binary");
        this.keys = await sheet.getKeysFromSheet((await sheet.getSheets())[0]);
      });
    }
  },
  watch: {
    file() {
      this.findKeys();
      if (this.file == null) {
        this.keys = [];
      }
    }
  }
};
</script>

<style></style>
